import React from "react";
import {Card, Col, DatePicker, Form, Input, message, Row, Skeleton} from "antd";
import {useFormik} from "formik";
import {useTranslation} from "react-i18next";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import * as Sentry from "@sentry/react";
import {useStore} from "../../../hooks/useStore";
import moment from "moment";
import * as yup from "yup";

export const PaymentInfoForm = ({subCompany, loading, refetch, okButtonText, isCustomer}) => {
    const stores = useStore();

    const {t} = useTranslation();

    const formik = useFormik({
        initialValues: {
            subCompanyId: subCompany?._id,
            accountTitle: subCompany?.paymentInfo?.cashOnDelivery?.accountTitle || "",
            iban: subCompany?.paymentInfo?.cashOnDelivery?.iban || "",
            bankName: subCompany?.paymentInfo?.cashOnDelivery?.bankName || ""
        },
        validationSchema: yup.object().shape({
            accountTitle: yup.string().required("Hesap ünvanı zorunludur"),
            iban: yup.string().required("IBAN zorunludur")
        }),
        enableReinitialize: true,
        onSubmit: async values => {
            try {
                const payload = {
                    subCompanyId: values.subCompanyId,
                    paymentType: "cashOnDelivery",
                    accountTitle: values.accountTitle,
                    iban: values.iban
                };
                const resultUpdateSubCompanyPaymentInfo = await stores.companyStore.updateSubcompanyPaymentInfo(
                    {
                        ...payload
                    }
                );

                if (resultUpdateSubCompanyPaymentInfo?.success !== true) {
                    message.error(resultUpdateSubCompanyPaymentInfo?.message);
                    return false;
                }
                refetch();
            } catch (error) {
                console.log(error);
                Sentry.captureException(error);
            }
        }
    });

    const {
        values,
        handleSubmit,
        handleChange,
        setFieldValue,
        isSubmitting,
        errors,
        touched
    } = formik;

    return (
        <Card title="Ödeme Bilgileri" style={{marginTop: "20px"}}>
            {loading ? (
                <Skeleton active />
            ) : (
                <Form
                    labelCol={{span: 24}}
                    wrapperCol={{span: 24}}
                    onFinish={data => {
                        handleSubmit(data);
                    }}
                    autoComplete="off"
                    data-testid="paymentInfoForm"
                >
                    <Row>
                        <Col span={24}>
                            <Row gutter={[16, 16]}>
                                <Col span={24}>
                                    <Form.Item>
                                        <h4>Hesap Ünvanı</h4>
                                        <Input
                                            name="accountTitle"
                                            value={values?.accountTitle}
                                            disabled={
                                                subCompany?.paymentInfo?.cashOnDelivery
                                                    ?.accountTitle
                                            }
                                            onChange={e => {
                                                handleChange(e);
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item>
                                        <h4>IBAN</h4>
                                        <Input
                                            name="iban"
                                            value={values?.iban}
                                            disabled={subCompany?.paymentInfo?.cashOnDelivery?.iban}
                                            onChange={e => {
                                                handleChange(e);
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                {subCompany?.paymentInfo?.cashOnDelivery?.bankName ? (
                                    <Col span={24}>
                                        <Form.Item>
                                            <h4>Banka Adı</h4>
                                            <Input
                                                name="bankName"
                                                value={values?.bankName}
                                                disabled={true}
                                                onChange={e => {
                                                    handleChange(e);
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                ) : (
                                    <></>
                                )}
                            </Row>
                        </Col>
                    </Row>
                    {(!subCompany?.paymentInfo?.cashOnDelivery?.iban ||
                        !subCompany?.paymentInfo?.cashOnDelivery?.accountTitle) && (
                        <Row type="flex" justify="end">
                            <CustomButton
                                disabled={isSubmitting}
                                type="ghost"
                                htmlType="submit"
                                data-testid="submitButton"
                                style={{
                                    backgroundColor: isCustomer ? "#AEFF01" : "transparent"
                                }}
                            >
                                {okButtonText || t("actions.save", {ns: "common"})}
                            </CustomButton>
                        </Row>
                    )}
                </Form>
            )}
        </Card>
    );
};
